import styles from './Search.module.css';
import {FaSearch} from "react-icons/fa";
import { useHistory } from 'react-router';
import { useQuery } from '../hooks/useQuery';

export function Search() {
    const query = useQuery();
    const search= query.get("search");
    const history = useHistory();  // Me va permitir añadir un nuevo elemento a la ruta  
    const handleSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <form className={styles.searchContainer} onSubmit={handleSubmit}>
            <div className={styles.searchBox}>
                <input className={styles.searchInput} 
                       type="text" 
                       value = {search}
                       placeholder="Título"
                       aria-label='Buscar película'
                       onChange={(e)=> {
                            const value = e.target.value; 
                            history.push("/?search="+value);
                       }}     
                       autoFocus
                 />
                 <FaSearch size={20} color="black"  
                           className={styles.searchButton}/>
            </div>
        </form>
    )
}
